import { render } from "./transfered_product_main_w.vue?vue&type=template&id=1597b030&scoped=true"
import script from "./transfered_product_main_w.vue?vue&type=script&lang=js"
export * from "./transfered_product_main_w.vue?vue&type=script&lang=js"

import "./transfered_product_main_w.vue?vue&type=style&index=0&id=1597b030&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1597b030"]])

export default __exports__